module.exports = __webpack_public_path__ + "img/crm.e54540a9.png";